import { render, staticRenderFns } from "./Inline.vue?vue&type=template&id=064b6e12&scoped=true&"
import script from "./Inline.vue?vue&type=script&lang=js&"
export * from "./Inline.vue?vue&type=script&lang=js&"
import style0 from "./Inline.vue?vue&type=style&index=0&id=064b6e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b6e12",
  null
  
)

export default component.exports